"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_FRACTION_DIGITS = exports.LANGUAGE_TO_CURRENCY_MAP = exports.SPECIAL_ENVIRONMENTS = exports.LANGUAGE_TO_DATE_LOCALE_MAP = exports.LANGUAGES_MAP = exports.LOCAL_STORAGE_KEY = exports.DETECTOR_NAME = exports.DEFAULT_NAMESPACES = exports.DEFAULT_LANGUAGE = void 0;
var DEFAULT_LANGUAGE = 'en-US';
exports.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
var DEFAULT_NAMESPACES = ['common', 'document', 'upsell'];
exports.DEFAULT_NAMESPACES = DEFAULT_NAMESPACES;
var DETECTOR_NAME = 'pandaDetector';
exports.DETECTOR_NAME = DETECTOR_NAME;
var LOCAL_STORAGE_KEY = 'locale language';
exports.LOCAL_STORAGE_KEY = LOCAL_STORAGE_KEY;
var LANGUAGES_MAP = {
  'en-US': 'English (United States)',
  'fr-FR': 'Français (France)',
  'it-IT': 'Italiano (Italia)',
  'es-ES': 'Español (España)',
  'nl-NL': 'Nederlands (Nederland)',
  'de-DE': 'Deutsch (Deutschland)',
  'pt-PT': 'Português (Portugal)',
  'pl-PL': 'Polski (Polska)',
  'sv-SE': 'Svenska (Sverige)'
};
exports.LANGUAGES_MAP = LANGUAGES_MAP;
var LANGUAGE_TO_DATE_LOCALE_MAP = {
  'en-US': function enUS() {
    return import('date-fns/locale/en-US/index.js');
  },
  'pt-BR': function ptBR() {
    return import('date-fns/locale/pt-BR/index.js');
  },
  'fr': function fr() {
    return import('date-fns/locale/fr/index.js');
  },
  'it': function it() {
    return import('date-fns/locale/it/index.js');
  },
  'es': function es() {
    return import('date-fns/locale/es/index.js');
  },
  'nl': function nl() {
    return import('date-fns/locale/nl/index.js');
  },
  'de': function de() {
    return import('date-fns/locale/de/index.js');
  },
  'pl': function pl() {
    return import('date-fns/locale/pl/index.js');
  },
  'pt': function pt() {
    return import('date-fns/locale/pt/index.js');
  },
  'sv': function sv() {
    return import('date-fns/locale/sv/index.js');
  }
};
exports.LANGUAGE_TO_DATE_LOCALE_MAP = LANGUAGE_TO_DATE_LOCALE_MAP;
var SPECIAL_ENVIRONMENTS = ['live', 'prod', 'stg01'];
exports.SPECIAL_ENVIRONMENTS = SPECIAL_ENVIRONMENTS;
var LANGUAGE_TO_CURRENCY_MAP = {
  'en-US': 'USD',
  'es-ES': 'EUR',
  'fr-FR': 'EUR',
  'nl-NL': 'EUR',
  'pl-PL': 'PLN',
  'sv-SE': 'SEK',
  'it-IT': 'EUR',
  'de-DE': 'EUR',
  'pt-PT': 'EUR'
};
exports.LANGUAGE_TO_CURRENCY_MAP = LANGUAGE_TO_CURRENCY_MAP;
var DEFAULT_FRACTION_DIGITS = 0;
exports.DEFAULT_FRACTION_DIGITS = DEFAULT_FRACTION_DIGITS;